// Notification System Types

// Channel types
export type NotificationChannelType = 'email' | 'sms' | 'whatsapp' | 'discord';

// Notification Channel
export interface NotificationChannel {
  id: string;
  user_id: string;
  organization_id: string;
  channel_type: NotificationChannelType;
  channel_value: string;
  label: string;
  is_verified: boolean;
  is_active: boolean;
  config?: NotificationChannelConfig;
  created_at: string;
  updated_at: string;
}

export interface NotificationChannelConfig {
  provider?: 'mailgun' | 'twilio' | 'sendgrid';
  preferences?: {
    format?: 'html' | 'text';
    timezone?: string;
    language?: string;
  };
}

// Create/Update DTOs
export interface CreateNotificationChannelDto {
  channel_type: NotificationChannelType;
  channel_value: string;
  label: string;
  config?: NotificationChannelConfig;
}

export interface UpdateNotificationChannelDto {
  label?: string;
  is_active?: boolean;
  config?: NotificationChannelConfig;
}

export interface NotificationChannelFilters {
  channel_type?: NotificationChannelType;
  is_active?: boolean;
  is_verified?: boolean;
}

// Icon/label mapping for UI
export const CHANNEL_TYPE_ICONS: Record<NotificationChannelType, string> = {
  email: '✉️',
  sms: '📱',
  whatsapp: '💬',
  discord: '🎮',
};

export const CHANNEL_TYPE_LABELS: Record<NotificationChannelType, string> = {
  email: 'Email',
  sms: 'SMS',
  whatsapp: 'WhatsApp',
  discord: 'Discord',
};
